import Vue from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faExternalLink,
    faAddressCard,
    faChartLine,
    faPersonWalkingLuggage,
    faArrowLeft,
    faArrowRight,
    faArrowRightFromBracket,
    faArrowUpRightFromSquare,
    faBars,
    faBox,
    faCalculator,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faFilePdf,
    faChevronRight,
    faCode,
    faExchangeAlt,
    faChevronUp,
    faCircleCheck as faCircleCheckSolid,
    faCircleExclamation,
    faCloudUploadAlt,
    faCommentDots,
    faComments,
    faCopy,
    faCubes,
    faEllipsis,
    faEllipsisVertical,
    faFileCircleCheck,
    faFileInvoiceDollar,
    faHome,
    faIdCard,
    faLaptop,
    faListCheck,
    faLocationDot,
    faLocationPin,
    faPencil,
    faPenToSquare,
    faPhone,
    faPhoneAlt,
    faPlus,
    faPuzzlePiece,
    faRightToBracket,
    faSearch,
    faTrash,
    faPrint,
    faTrashCan,
    faUsers,
    faCalendar,
    faCalendarDay,
    faEnvelope,
    faBoxesStacked,
    faRobot,
    faUser,
    faLock,
    faTable,
    faFileDownload,
    faUpload,
    faBell,
    faCircleXmark,
    faChartSimple,
    faArrowTrendUp,
    faClock,
    faPhoneVolume,
    faClipboardCheck,
    faHandHoldingDollar,
    faArrowsRotate,
    faArrowCircleRight,
    faEye,
    faBoxOpen,
    faTaxi,
    faBus,
    faBuilding,
    faHelmetSafety,
    faHourglass,
    faHeadset,
    faMoneyBill1Wave,
    faMoneyBill,
    faReceipt,
    faMoneyBills,
    faIdBadge,
    faWifi,
    faCartShopping,
    faTags,
    faTag,
    faUserMinus,
    faMinus,
    faPercent,
    faCameraRetro,
    faCirclePlus,
    faPaperPlane,
    faEyeSlash,
    faUserPlus,
    faPersonWalkingArrowRight,
    faTriangleExclamation,
    faCodePullRequest,
    faBriefcase,
    faMoneyCheckDollar,
    faStore,
    faDiagramProject,
    faUnlock,
    faAngleDown,
    faAngleUp,
    faMoneyBill1,
    faColumns,
    faList,
    faGears,
    faClipboard,
    faPaperclip,
    faCheckToSlot,
    faUserShield,
    faLaptopCode, faCalendarDays,
    faCloudArrowDown, faFileContract, faCircleChevronLeft, faCircleChevronRight, faXmark,faThLarge,faSort,faSortDown,faUserTie,faCalendarPlus,
    faUsersCog,
    faBookSkull,faChartPie,faCheckSquare,faFlag,faFileExport,faArrowUp,faSquare,faSpinner,faTicketAlt,
    faTruck,
    faMapMarkerAlt,
    faInfoCircle,
    faCalendarAlt,
    faSync,
    faFileAlt,
    faFileInvoice,
    faDownload,
    faMapMarkedAlt,
    faCheckCircle,
    faTimes,
    faBullseye,
    faCalendarCheck,
    faPersonWalking,
    faListOl,
    faUndo,
    faMoneyBillWave

} from '@fortawesome/free-solid-svg-icons'
import {faCircleCheck, faCommentDots as faCommentDotsR} from '@fortawesome/free-regular-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faEllipsisVertical, faEllipsis, faPlus, faTags, faTag, faPercent, faArrowLeft, faArrowRight, faHome, faBars, faChevronLeft, faCopy, faEnvelope, faRobot, faUser, faTable, faChartSimple, faCubes,
    faChevronRight, faCircleExclamation, faPencil, faTrash, faUsers, faLocationPin, faAddressCard, faLocationDot, faPenToSquare, faLock, faMoneyBills, faExternalLink,
    faTrashCan, faRightToBracket, faCommentDots, faArrowRightFromBracket, faCircleCheckSolid, faCircleCheck, faChevronUp, faBoxesStacked, faFileDownload, faUpload, faArrowsRotate, faIdBadge, faIdCard,
    faChevronDown, faListCheck, faComments, faPrint, faCommentDotsR, faFileInvoiceDollar, faFileCircleCheck, faArrowUpRightFromSquare, faSearch, faCircleXmark, faHandHoldingDollar, faArrowCircleRight,
    faPhone, faPhoneAlt, faCalendar, faCalendarDay, faBell, faArrowTrendUp, faClock, faPhoneVolume, faClipboardCheck, faEye, faBoxOpen, faTaxi, faBus, faBuilding, faHelmetSafety, faHourglass, faHeadset, faMoneyBill1Wave, faMoneyBill, faReceipt, faWifi,
    faChartLine, faCameraRetro, faCirclePlus, faPersonWalkingLuggage, faFilePdf, faPaperPlane, faPencil, faEyeSlash, faUserPlus, faPersonWalkingArrowRight, faCartShopping, faUserMinus, faMinus, faTriangleExclamation, faBriefcase,
    faMoneyCheckDollar, faStore, faDiagramProject, faUnlock, faAngleDown, faAngleUp, faMoneyBill1, faColumns, faList, faGears, faClipboard, faPaperclip,
    faCircleChevronRight, faCircleChevronLeft, faFileContract, faCloudArrowDown, faCloudUploadAlt, faUserTie, faCalendarPlus,
    faMoneyCheckDollar, faStore, faDiagramProject, faUnlock, faAngleDown, faAngleUp, faMoneyBill1, faColumns, faList, faGears, faClipboard, faPaperclip, faCodePullRequest,
    faXmark, faThLarge, faSort, faSortDown, faExchangeAlt, faCheck, faCalculator,
    faCheckToSlot, faUserShield, faLaptopCode, faLaptop, faCalendarDays, faBookSkull, faCheckToSlot, faUserShield, faLaptopCode, faCalendarDays, faUsersCog, faChartPie, faCheckSquare, faFlag, faFileExport, faArrowUp, faSquare, faSpinner, faTicketAlt, faTruck,
    faBox, faPuzzlePiece, faCode,
    faMapMarkerAlt, faInfoCircle, faCalendarAlt, faSync, faFileAlt, faFileInvoice, faDownload, faMapMarkedAlt, faCheckCircle, faTimes, faBullseye, faCalendarCheck, faPersonWalking, faListOl, faUndo, faMoneyBillWave
)
